/* @flow */

import React from 'react'
import Auth from '../utils/auth';
const auth = new Auth();
// const hhsCx = 'pad-r-1 flex-box dir-column m-marg-t-2 m-marg-l-2 hhs'
const hhsCx = ''
const hhsACx = 'clr-white relative'
// const hhsACx = 'clr-white relative hhs'

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          authenticated: false,
          username: '',
        };
        // this.state = {
        //   username: ''
        // }
      }

    login() {
        //const type = {type: 'login'};
        const email2 = {email: ''};
        auth.login(email2);
         this.setState({authenticated: auth.isAuthenticated()},function(){ 
           // this.setState({username: auth.getUserName()})
         });
         this.setState({
          username: auth.getUserName(),
        })
        // this.setState({
        //   authenticated: auth.isAuthenticated(),
        // });
      }
    
      logout() {
        auth.logout();
         this.setState({authenticated: auth.isAuthenticated()},function(){  
         });
         this.setState({
           username: '',
         })
      }
    
      componentDidMount() {
        this.setState({
          authenticated: auth.isAuthenticated(),
          username:auth.getUserName(),
        });
      }

      componentDidUpdate(prevProps, prevState) {
        if ((auth.isAuthenticated()) && !prevState.authenticated) {
         this.setState({
           authenticated: auth.isAuthenticated(),
           username:auth.getUserName(),
         });
        }
      }

  render() {

    return (
        <div className="container clr-white smallest blue-nav-bar">
        {/* <a
          href="https://www.fronttobackculture.com/"
          className="col self-start"
          rel="noopener noreferrer"
          target="_blank"
          style={{
            verticalAlign: 'text-top',
          }}
        >
          <img
            alt="Go to Front to Back Culutre website"
            width="180px"
            src="/img/FTBCLogoWhite.png"
          />
        </a> */}
        <div className={hhsCx}>
          {
            !this.state.authenticated && (
              <span>
                <a href="#"
                  className={hhsACx}
                  onClick={this.login.bind(this)}
                >
                  Sign In
                </a>
              </span>
              
            )
          }
          {
            this.state.authenticated && (
              <span>
                <a href="#"
                  className={hhsACx}
                  onClick={this.logout.bind(this)}
                >
                  Log Out
                  {
                    //  auth.getUserName() && (
                    //   <span> | {auth.getUserName()} </span>                      
                    //  )
                    this.state.username && (
                      <span> | {this.state.username} </span>                      
                     )
                  }
                  {
                    //  !auth.getUserName() && (
                    //   <span> | You are login </span>
                    //  )
                    !this.state.username && (
                      <span> | You are signed in </span>
                     )
                  }
                </a>
              </span>
            )
          }
            {/* A product of Front To Back Culture */}
        </div>
        <div
          className="txt-c right flex-box clearfix"
          style={{
            // ie stuff, mobile stuff
            fontSize: '13px',
            // ie needs more width than others
            maxWidth: '345px',
          }}
        >
          {/*<img
        { ...ARIA.hide }
        alt='United States Flag'
        className='float-l'
        height='11px'
        src='/img/us_flag_small.png'
        style={{
          height: '11px',
          marginRight: '5px',
          marginTop: '3px',
        }}
        width='16px'
      />
      <span className='inline-block float-l'>
        An official website of the United States Government
      </span>*/}
        </div>
      </div>
    )
  }
}

Header.displayName = 'components/Header'
export default Header



// WEBPACK FOOTER //
// ./src/components/Header.jsx